module.exports = __webpack_public_path__ + "static/media/Korea_Exhibition_05.2c2d1690.JPG";